import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from '@fluentui/react';
import * as React from 'react';

export interface IConfirmDialogProps {
    isOpen: boolean;
    title?: string;
    subText?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmDialog: React.FunctionComponent<IConfirmDialogProps> = ({ isOpen, title = 'Bekræft', subText, onConfirm, onCancel }) => {
    return (
        <Dialog
            hidden={!isOpen}
            onDismiss={onCancel}            
            dialogContentProps={{ type: DialogType.largeHeader, title, subText }}
            modalProps={{ isBlocking: true }}
            minWidth={480}
        >
            <DialogFooter>
                <PrimaryButton text='Ja' onClick={onConfirm} />
                <DefaultButton text='Annuller' onClick={onCancel} />
            </DialogFooter>
        </Dialog>
    );
};

export default ConfirmDialog;
